<template>
    <div class="detailBox">
        <div class="titleBox">
            <p></p>
            <h4>查看保单保函</h4>
        </div>
        <avue-crud :data="data" :option="option" >
            <template slot="menu" slot-scope="scope" >
                <a :href="scope.row.all_url" target="_blank" style="color: #ffffff"><el-button type="primary">查看文件</el-button></a>
            </template>
        </avue-crud>
        <div class="btnType" v-if="jd_type_id==5">
            <el-button type="primary" @click="errorlessBtn">确认无误</el-button>
            <el-button type="primary" @click="dialogVisible = true">确认有误</el-button>
        </div>
<!--        保单保函确认有误-->
        <el-dialog
                title="确认保单保函"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <p style="margin: 0px 10px 20px 10px">请确认该保单保函是否有误，如果有问题请填写错误理由</p>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="错误理由" prop="argument">
                    <el-input v-model="form.argument"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="errorBtn">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import { confirmationPolicy, insurancePolicyDetail } from '../../../api/insure';

    export default {
        name: 'insurancePolicy',
        inject:['reload'],
        data() {
            return {
                form:{
                    argument:'',
                },
                dialogVisible:false,
                data: [],
                jd_type_id:'',
                rules:{
                    argument:[
                        { required: true, message: '请填写错误理由' },
                    ]
                },
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        }
                    ]
                },
            };
        },
        methods:{
            //无误
            errorlessBtn(){
                this.$confirm('请确认该保单保函是否无误 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    confirmationPolicy(this.$route.query.id,1).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                            this.reload()
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            },
            //有误
            errorBtn(){
                if (this.form.argument==''){
                    this.$message.error('请填写错误理由')
                }else {
                    confirmationPolicy(this.$route.query.id,2,this.form.argument).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg)
                            this.reload()
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }
            }
        },
        created() {
            insurancePolicyDetail({case_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    this.jd_type_id=res.data.jd_type_id
                    this.data=res.data.daiqueren_wenshu
                }else{
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .detailBox{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .titleBox{
        display: flex;
        align-items: center;
        color: #3e62f6;
    }
    .titleBox>p{
        width: 5px;
        height: 18px;
        margin-right: 10px;
        background-color: #3e62f6;
    }
    .btnType{
        margin: 40px 0px;
        text-align: center;
    }
</style>
